import en from '../../../lang/en-us';
import { isMobileDevice } from '../../../utils/constants';

const { } = en;

function TermsOfUse(props: any) {
    return (
        <div className="curved-bg terms-content">
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    {isMobileDevice() && <img src="/images/left-arrow-black.svg" alt="icon" />}
                </a>
                MF Central - Terms of Use
            </h2>
            <div className="curved-bg-content">
                <p>
                    This login screen is intended for valid and authorized users of this application
                    only and at their own discretion. Illegal or unauthorized access could lead to
                    legal action.
                </p>
                <p>
                    The Terms of Use (“Terms”) herein sets out the terms and conditions for availing
                    the Services of Unified Platform by You.
                </p>
                <h3>General</h3>
                <p>
                    By using/installing the Unified Platform (as defined below) at your own
                    discretion, you (hereinafter referred to as “the User”) agree to be legally
                    bound by the terms and conditions given herein below.{' '}
                </p>
                <p>
                    You are requested to read the following terms and conditions carefully before
                    installation of the Unified Platform or accessing the Platform and/or acceptance
                    of the following terms and conditions.
                </p>
                <h3>Definition</h3>
                <p>
                    The “Unified Platform” (hereinafter referred to as “MF Central” or
                    “App/platform”), shall mean the common platform jointly developed by Qualified
                    RTAs (“QRTAs”) namely M/s. Computer Age Management Services Private Limited
                    (“CAMS”) and M/s. KFin Technologies Private Limited (“KFintech to facilitate
                    uniform services across Mutual Funds in India, as QRTAs or as mandated by SEBI,
                    may decide from time to time, pertaining to financial and other service
                    transactions relating to Mutual Funds serviced by above referred QRTAs, to be
                    used through designated desktops/laptops, on Apple iOS (Apple’s mobile operating
                    system) and Android OS (Android operating system) devices and any upgrades from
                    time to time and any other software or documentation which enables the use of
                    the platform.
                </p>
                <h3>Collection of User Data :</h3>
                <p>
                    We collect the user’s personal information through our website/through the
                    app/platform. The data collected includes Name, Date of Birth, Address, Mobile,
                    Email, Age, Telephone Nos., Bank Account details, Income Tax PAN, FATCA/CRS
                    details, etc. These details are primary meant to be used for the purpose of
                    transacting the investment transactions effected by the user through the
                    app/platform at his/her own discretion and for communication on such
                    transactions or any other activities associated with such transactions including
                    reminders, intimation of any regulatory/statutory requirements, intimation of
                    specific events, etc..
                </p>
                <h3>Usage of information collected :</h3>
                <p>The information collected may also be used for the following purposes :</p>
                <ol>
                    <li>
                        Personalize your experience and improvise our responses to match your
                        requirements, wherever possible.
                    </li>
                    <li>
                        Improve our app/platform based on the information/details about investor
                        profiles, servicing patterns and their exact requirements, etc.
                    </li>
                    <li>
                        To improve customer service based on the feedbacks provided by the user.
                    </li>
                    <li>
                        Use analytics to track the traffic patterns, sources of traffic, user
                        preferences, referrals etc. and use such analytics to enhance overall
                        services.
                    </li>
                    <li>
                        To send periodic emails/SMS to registered email IDs / mobile numbers.
                        Further, these email IDs / mobile number may be used to send you information
                        and updates pertaining to your order or request, in addition to receiving
                        periodic news / updates / promotions / related product or services provided
                        by QRTAs and its group companies / subsidiaries and informative and
                        educative material(s) that we may deem appropriate.
                    </li>
                    <li>
                        We commit and promise that the User’s email IDs, mobile numbers, and other
                        personal information shared with us, shall be kept confidential and safe
                        with the respective QRTAs.
                    </li>
                </ol>
                <h3>In-app/platform Disclosure</h3>
                <p>
                    The terms and conditions and the privacy policy contained in this app/platform
                    constitutes complete disclosure and the users are not required to navigate
                    further outside the app/platform. These terms and conditions describe in detail
                    the type of data being collected and how the data will be used apart from other
                    details.
                </p>
                <h3>Request for consent</h3>
                <p>
                    The consent for the collection of data which may include personal or sensitive
                    data and for the subsequent use of the data is being sought from the user by
                    clicking on the app/platform appropriate acceptance boxes contained in the
                    app/platform. This affirmative action by the user is a prerequisite for the use
                    of the app/platform further. The acceptance needs to be done at the specified
                    space in an affirmative manner as stated above and no other action of the user
                    will be considered as consent. Collection of the data referred above will
                    commence post receipt of the consent.
                </p>
                <h3>Privacy Shield</h3>
                <p>
                    This app/platform does not intend to use personal information made available by
                    Google or any such website/app that directly or indirectly identifies an
                    individual and that originated in the European Union or Switzerland, or any
                    other countries added from time to time. However, the app/platform can be used
                    by users located in these regions at their own discretion subject to compliance
                    with the relevant regulations associated in those regions.
                </p>
                <h3>Malicious Behavior</h3>
                <p>
                    MF Central doesn’t allow any other app/platforms to steal data, secretly monitor
                    or harm users, or are otherwise give access to any other platform which are
                    malicious in nature. The following are expressly prohibited:
                </p>
                <ol>
                    <li>
                        Viruses, trojan horses, malware, spyware, or any other malicious software;
                    </li>
                    <li>
                        App/platforms that link to or facilitate the distribution or installation of
                        malicious software;
                    </li>
                    <li>
                        App/platforms or Software Development Kit “SDKs” that download executable
                        code, such as dex files or native code, from a source other than Google
                        Play;
                    </li>
                    <li>App/platforms that introduce or exploit security vulnerabilities;</li>
                    <li>
                        App/platforms that steal a user’s authentication information (such as
                        usernames or passwords) or that mimic other app/platforms or websites to
                        trick users into disclosing personal or authentication information;
                    </li>
                    <li>
                        App/platforms that install other app/platforms on a device without the
                        user’s prior consent;
                    </li>
                    <li>
                        App/platforms designed to secretly collect device usage, such as commercial
                        spyware app/platforms.
                    </li>
                </ol>
                <h3>Intellectual Property Rights:</h3>
                <p>
                    All trademarks, copyright, database rights and other intellectual property
                    rights associated with the app/platform together with the underlying software
                    code are owned directly & jointly by the QRTAs
                </p>
                <p>
                    Any unauthorized reproduction, republication, distribution, display,
                    transmission, sale, or any other use and/or duplication of any material
                    available on App/platform, without express and written approval of the QRTAs
                    shall be violation of the relevant intellectual property laws.
                </p>
                <h3>Eligibility for Registration & Services for MF Central: </h3>
                <p>
                    Existing Investor/folio holder of a Mutual Fund serviced by respective QRTAs
                    shall be authorized to register for MF Central/App/Platform and to avail the
                    services provided only upon fulfilling the following requirements -
                </p>
                <ol>
                    <li>
                        shall be a Resident Indian Individual and who is Know Your Client (“KYC”)
                        compliant;
                    </li>
                    <li>
                        shall have mode of operation / holding of the existing folio as "single" or
                        as "anyone or survivor" and having an email ID registered in the folio
                    </li>
                </ol>
                <p>
                    Depending upon the requirements, QRTAs may add / modify the eligibility
                    conditions from time to time basis, at its own discretion.
                </p>
                <h3>System Requirements :</h3>
                <p>
                    In order to use the App/platform, you are required to have a compatible desktop
                    / laptop / mobile telephone or any other compatible device, internet access and
                    the necessary minimum specifications.
                </p>
                <h3>Software Requirements :</h3>
                <p>
                    MF Central, shall on a best effort basis support the mobile operating systems
                    such as Android, App/platform, Apple iOS and Windows. Platform does not
                    guarantee full compatibility for each type of systems/mobile phone/device
                    display pertaining to size, pixels, and its mobile operating system in current
                    or later versions due to the multitude of operating systems and their different
                    functioning caused by specific features. QRTAs shall inform about any such
                    updates to the App/platform through any communication channel as decided by
                    QRTAs.
                </p>
                <h3>Registration :</h3>
                <p>
                    To submit transactions for all folios across mutual funds serviced by QRTAs in
                    MF Central, relevant App/platform registration is required, and it is allowed
                    based on the email ID registered / available at folio level in the respective
                    mutual funds. The App/platform shall be downloaded from mobile store / through{' '}
                    <a href="https://www.camsonline.com" target="_blank">
                        https://www.camsonline.com
                    </a>{' '}
                    or{' '}
                    <a href="https://www.kfintech.com" target="_blank">
                        https://www.kfintech.com
                    </a>{' '}
                    and logged-in with the provided login credentials subject to the condition that
                    the login credentials are changed upon first login and kept secure by the
                    investors. The user may also be required to enter the One Time Password(OTP)
                    sent to his registered mobile No to proceed with registration.
                </p>
                <p>
                    QRTAs shall endeavor to provide to the User through MF Central, such services as
                    QRTAs may decide from time to time. QRTAs reserves its right to decide the type
                    of services, which a category of User may be offered on each account and may
                    differ from category to category.
                </p>
                <p>
                    QRTAs at its sole discretion shall add /delete the services offered to the User
                    through MF Central.
                </p>
                <p>Access to MF Central app/platform shall be restricted -</p>
                <ol>
                    <li>
                        if the user allows any other person to have access to MF Central
                        App/platform other than the registered user or/and;
                    </li>
                    <li>
                        if the user attempts or permits to attempt accessing the account information
                        stored in the mobile through any unauthorized means.
                    </li>
                </ol>
                <p>
                    The User of MF Central grants express irrevocable authority to QRTAs to act upon
                    any instruction given by the User through MF Central, as may be permitted
                    through the app/platform from time to time and until valid termination of MF
                    Central app/platform service by the User. QRTAs shall have no obligation to
                    verify the authenticity of any transaction(s) received through MF Central or
                    purporting to have been sent by the User via MF Central other than by means of
                    verification of the login credentials.
                </p>
                <p>
                    The display shown at the time of operation of MF Central in the mobile
                    phone/device is a proof of record that the operation was made with the use of
                    mobile phone/device and shall not be construed as final record of the
                    transaction. The records maintained by QRTAs at its end through computer systems
                    will be deemed as final and conclusive, which will be the binding evidence for
                    all purposes.
                </p>
                <p>
                    In case of folios where mode of holding is "anyone or survivor", the login
                    details will be sent to the first Unit Holder only and all transactions arising
                    from the use of MF Central from such folios, shall be binding on all the joint
                    account holders in the folio, and all such holders are deemed to be aware of the
                    entire terms and conditions set forth in this document. Usage of the MF Central
                    shall be in addition to, and not in substitution of, the existing procedure for
                    conducting transactions.
                </p>
                <h3>QRTAs Portfolio View:</h3>
                <p>
                    This is to confirm my/our acceptance and app/platform approval to request for
                    and to download the data as available in the Consolidated Account Statement (an
                    initiative by both RTAs to provide one view of holdings of an investor), across
                    all Mutual Funds. I am / We are also providing my/our app/platform approval for
                    MF Central to store such data for my/our convenience of getting one consolidated
                    view and QRTAs will not be held liable for any consequences, whatsoever, due to
                    this action and I/We shall keep QRTAs Indemnified against any claims /
                    litigations"
                </p>
                <h3>Usage by minors:</h3>
                <p>
                    MF Central is not intended for use by minors. The user should ensure that only
                    the guardian of the Minor shall avail this service. In the event, any loss
                    arises as a result of transaction entered by the minor, the QRTAs shall not be
                    held liable for any such loss/damages.{' '}
                </p>
                <h3>Responsibility & Obligation of the User</h3>
                <p>
                    The User of MF Central App/platform accepts to have read and understood the
                    terms and contents of the Scheme Information Document(s), Statement of
                    Additional Information and Offer Documents of the respective Mutual Fund and
                    their Scheme(s).
                </p>
                <p>
                    The User hereby agrees and accepts to the terms and conditions of the respective
                    Mutual Fund for allotment of Units in the Scheme(s) and processing of
                    transactions in the respective Mutual Fund.
                </p>
                <p>
                    The User hereby declares that they are authorized to make the investment, and
                    the amount invested in the Scheme is through legitimate sources and does not
                    involve and is not designed for any contravention or evasion of any Act, Rules,
                    Regulations, Notifications/Circulars/Guidelines or Directions issued by any
                    regulatory authority in India.
                </p>
                <p>
                    The User hereby confirms that the subscription amount is debited from the bank
                    account as registered with the respective Asset Management Company (“AMC”) and
                    not from any other third-party account / fictitious account.
                </p>
                <p>
                    The User hereby understands, acknowledges, and confirms that in the event any
                    application made for subscription is made through the app/platform does not
                    comply with the provisions of the Scheme Information Documents (“SID”), the AMC
                    or Trustees or the Mutual Fund or its Registrar Transfer Agent (RTA) retains the
                    absolute right and discretion to reject and not to process such application, and
                    refund the subscription money.
                </p>
                <p>
                    The User acknowledges that the terms of agreement with your respective mobile
                    phone/device network provider will continue to apply when using the
                    App/platform. As a result, the user may be charged by the mobile phone/device
                    network provider for access to network connection services for the duration of
                    the connection while accessing the App/platform or any such third-party charges
                    as may arise. The User accepts responsibility for any such charges that arise.
                </p>
                <p>
                    The User accepts that transaction instructions entered on non-business days will
                    be processed on the following business day.
                </p>
                <p>
                    The User accepts that the information provided to the User through MF Central
                    may not be updated on a real-time basis. Consequently, any information supplied
                    to the User will pertain to the date and time when it was last updated. QRTAs/
                    the AMC/participating Funds shall not be liable for any loss that the User may
                    suffer by relying on or acting on such information.
                </p>
                <p>
                    The User accepts that their use of MF Central shall be subject to the terms and
                    conditions of any applicable agreements between QRTAs, Service Providers and the
                    AMC/the Mutual Fund and /or the User.
                </p>
                <p>
                    The User understands that the payment for the transaction request shall be
                    through a payment gateway and the AMC/the Mutual Fund/ Trustees/Sponsors/QRTAs
                    will not be liable for any failures in the link or for any fraud (either at the
                    payment gateway's end and/or the bank's end) that could take place at the time
                    of making payment and the User undertakes to inform QRTAs immediately in case
                    the Unit holder's bank account is debited but corresponding Units are not
                    allotted to the Unit holder.
                </p>
                <h3>Applicable NAV / Cut off timings</h3>
                <p>
                    The transaction instructions given by the User through MF Central will get
                    processed at the Applicable NAV based on the cut off time indicated in the SID
                    of the respective schemes of the Mutual Fund.{' '}
                </p>
                <p>
                    Any transaction request shall be processed by concerned QRTA (CAMS/KFintech)
                    only based on the date and time of receipt of the transaction by QRTAs, as
                    evidenced by the date and time of receipt of the transaction as per concerned
                    QRTA (CAMS/KFintech) servers and the realization / utilization of clear funds by
                    the AMC/ the Mutual Fund and in accordance with the provisions of the SID of the
                    respective Schemes.
                </p>
                <h3>Limitation of Liability</h3>
                <p>
                    In no event, shall QRTAs or the AMC or the Trustee Company or the Mutual Fund or
                    its Sponsors or their associates or any person connected with it be liable for
                    any direct, indirect, special, consequential or other damages (including,
                    without limitation, any loss of profits, goodwill, business interruption) that
                    are related to the User’s use or access to the App/platform,
                </p>
                <h3>Indemnity</h3>
                <p>
                    The User hereby accepts the sole responsibility for maintenance of the password
                    of MF Central, and that the QRTAs, AMC, Trustee Company, the Mutual Fund and its
                    Sponsors, their associates, and any person connected with it shall not be held
                    liable for any loss suffered by the User due to disclosure of the password and
                    other personal information to a third party.
                </p>
                <p>
                    The User understands that the User's mobile phone/device can be misused in the
                    event of loss of the mobile phone/device, or it is falling in the wrong hands.
                    The User shall not hold QRTAs, the AMC, the Trustee Company, the Mutual Fund,
                    its Sponsors, their associates, and any person connected with it, responsible
                    for any loss that the User or any third party may suffer due to such
                    circumstances.
                </p>
                <p>
                    The User shall at all times indemnify QRTAs, the AMC, the Trustee Company, the
                    Mutual Fund, its Sponsors, their associates and any person connected with it,
                    from and against any and all actions, proceedings, claims and demands whatsoever
                    for or on account of or in relation to any use / misuse of the MF Central by the
                    User or any third party using the User's login credentials, and from and against
                    any and all damages, costs, liabilities, charges and expenses or other loss
                    relating to the use of MF Central in any manner, including without limitation
                    any action of User which is in violation of these terms and conditions and
                    against any applicable law.
                </p>
                <p>
                    The User agrees that any transaction/ information that is entered through MF
                    Central with the provided login credentials, whether initiated by the User or
                    not, shall be deemed to have originated from the User. The User shall be held
                    liable for all transactions and any losses from unauthorized transactions in the
                    User's folio through MF Central.
                </p>
                <p>
                    The User hereby accepts that in case of any discrepancy or any error in the
                    information in MF Central, the User shall inform respective QRTAs immediately.
                    QRTAs will endeavor to correct the error promptly wherever possible on a best
                    error basis.
                </p>
                <h3>Termination & Suspension of MF Central Service :</h3>
                <p>
                    QRTAs may terminate use of the App/platform at any time by giving notice of
                    termination to the User for such reason as QRTAs / the AMC may, in its sole and
                    absolute discretion deem proper.
                </p>
                <p>
                    QRTAs may change, suspend or discontinue any aspect of the MF Central, including
                    the availability of any feature(s) of the, at any time by giving notice to the
                    User for such changes.{' '}
                </p>
                <p>
                    The User can request for termination of the MF Central Services at any time by
                    giving 15 days prior written notice to QRTAs.
                </p>
                <p>
                    The User agrees that the User shall remain responsible for any transactions made
                    on MF Central until the services are terminated.
                </p>
                <p>
                    The QRTAs shall not be liable for any costs, expenses, or damages as a result of
                    the termination of these Terms.
                </p>
                <h3>Confidentiality and Security Protocol </h3>
                <p>
                    QRTAs falls under the category of Qualified Registrar and Transfer Agent
                    (“QRTA”) as defined by Securities and Exchange Board of India (“SEBI”) and SEBI
                    vide its circular dated August, 10, 2018 has mandated that all QRTAs should
                    enter into written agreements with all the entities accessing the mutual fund
                    data base maintained by QRTAs and accordingly QRTAs hereby request you to accept
                    MF Central’s “Confidentiality and Security Protocol” to continue to make
                    investment transactions securely at MF Central. This shall be in addition to the
                    above-mentioned terms and conditions for usage of MF Central which have already
                    been signed by you.
                </p>
                <h3>Effective Date :</h3>
                <p>
                    These T&Cs shall come into effect the moment you “Agree” the check box provided
                    at the end of MF Central Confidentiality and Security Protocol Terms and
                    Conditions.
                </p>
                <h3>Definitions :</h3>
                <p>
                    “Database access/Electronic Access” shall mean access to the MF Central
                    App/platform of QRTAs through proprietary app/platform, web portal or online
                    platforms or any other mode of access which has been provided by QRTAs currently
                    or may be provided by QRTAs in future and integrated with your systems in the
                    manner and upon the terms and conditions contained herein.
                </p>
                <p>
                    “QRTAs Systems/QRTAs Database” shall mean the data structure that stores
                    organized information that is established and maintained by QRTAs (both primary
                    and secondary) which allows data to be easily accessed by you. The access to the
                    data base by you shall be through one or more modes as provided herein.
                </p>
                <p>
                    “Confidential Information” shall mean any information that comes to your
                    knowledge while accessing the database of QRTAs and any other information which
                    is categorized as “confidential,” “proprietary” or under any such terminology
                    under any other agreement/document as in force between QRTAs and you.
                </p>
                <p>
                    “Cyber Incidents” refers to any event that threatens the security,
                    confidentiality, integrity, or availability of information assets (electronic or
                    paper), information systems, and/or the networks of you or QRTAs and which may
                    result in a security threat to the investor database maintained by QRTAs
                    Database on behalf of its clients or to any other data or IT assets of QRTAs.
                </p>
                <p>
                    Data Access and Data Protection Policy (“DADP Policy”) – DADP policy adopted by
                    QRTAs to ensure secured electronic data access by investors, Asset Management
                    Companies, Investment Managers, Service Providers, custodians of securities,
                    depositories and other QRTAs and assure effective and smooth investor serving
                    and eliminate all sorts of risks involved in the process of providing investor
                    servicing. The DADP policy consists of Protocol, Process, and Controls for the
                    activities of the users who wish to have electronic access to the QRTAs database
                    / server in any mode.
                </p>
                <p>
                    “Log-in Credentials” means the credentials given to you, your employees, agents,
                    authorized representatives etc. in order to access the QRTAs Mutual Fund
                    database maintained by QRTAs through the MF Central app/platform. The same may
                    be provided from time to time at your request in the specified manner.
                </p>
                <p>
                    “Process”– The mode of access including the security protocol formed by QRTAs
                    will be informed to you /authorized user from time to time to ensure secured
                    electronic data access to QRTAS database.
                </p>
                <p>
                    “Procedure” – The set of processes followed by QRTAs as part of its activities
                    for securing the electronic database.
                </p>
                <p>
                    “Security Protocol” – a set of procedures adopted by QRTAs, for ensuring
                    security of the data base maintained by it and built into the app/platform made
                    available to you, which shall be utilized by you without any modification.
                </p>
                <p>
                    “API” - An app/platform programming interface (“API”) is a set of routines,
                    protocols, and tools for building software app/platform for accessing the MF
                    Central App/platform maintained by QRTAs.
                </p>
                <h3>Confidentiality :</h3>
                <p>
                    You hereby acknowledge that all information accessed by you with the usage of
                    various existing app/platform solutions or any future app/platform that may be
                    developed by QRTAs from time to time is confidential information (“Confidential
                    Information”).You hereby agree that during the term of your usage of the MF
                    Central, and thereafter for so long as the Confidential Information is not in
                    the public domain, You shall: (a) take all reasonable care and precautions to
                    prevent third parties/other parties from gaining unauthorized access to the
                    Confidential Information;(b) shall share it with employees, agents and
                    authorised representatives who ‘need to know’ the Confidential Information for
                    the sole purpose of availing services of MF Platform; (c) ensure that you, your
                    employees, agents, authorized representatives etc. maintain the Confidential
                    Information in strictest confidence and in accordance with the confidentiality
                    obligations hereunder; and (d) shall only use the Confidential Information for
                    the sole purpose of availing the services of MF Platform and not otherwise.
                </p>
                <p>
                    The foregoing obligations of confidentiality shall not apply if the Confidential
                    Information (i) is already in your knowledge prior to the accessing the
                    confidential information; (ii) is or becomes publicly known through no wrongful
                    act or breach of your obligations hereunder; (iii) is rightfully received from
                    third party other than by reason of a breach of any obligation owed to QRTAs
                    hereunder; (iv) is independently developed by you without reference to
                    Confidential Information provided by QRTAs; (v) is approved for release by
                    written authorization of QRTAs; (vi) is disclosed pursuant to the order of a
                    regulatory agency or court of law, provided you shall give QRTAs reasonable
                    advance notice to contest the disclosure and you shall comply with any
                    applicable protective order or equivalent obtained by QRTAs;
                </p>
                <p>
                    Data accessed shall be used only for the purpose for which it was authorized or
                    obtained by you and shall not be used for any other purposes/ any unlawful
                    purpose or in violation of any applicable laws.
                </p>
                <p>
                    The receipt of any Confidential Information by you does not confer any
                    intellectual property rights in the said Confidential Information.
                </p>
                <p>
                    You shall at all times comply with all the applicable laws pertaining to
                    Confidentiality and Data Protection.
                </p>
                <p>The data shall also be purged by you, once the requirement is completed.</p>
                <h3>Security Protocols :</h3>
                <ol>
                    <li>
                        Your network shall be protected with Firewall, Intrusion Detection and
                        Prevention System and other means of Access Control, which in the opinion of
                        QRTAs are adequate and capable of protecting the network against
                        unauthorized access. You shall be entitled to add any other additional
                        security features as you may consider necessary;
                    </li>
                    <li>
                        You shall have adequate access control measures and the measures shall
                        always remain active and shall not be removed or reconfigured which could
                        create or enhance the risk of unauthorized access to the QRTAs network;
                    </li>
                    <li>
                        You shall also ensure that the access to QRTAs Database is adequately
                        controlled in such a way that unauthorized access is prevented;
                    </li>
                    <li>
                        You shall always have adequate Virus Detection and Control measures in your
                        network;
                    </li>
                    <li>
                        You shall immediately notify any Cyber incidents to QRTAs such as
                        unauthorized access or any type of cyber-attack taking place into your
                        network;
                    </li>
                    <li>
                        You hereby agree that you and your group entities and their
                        officers/directors/employees, third parties, advisers and auditors shall
                        keep confidentiality of all information about the App/platform, hardware,
                        data, the network diagram, the IP addresses, the Network Architecture, the
                        Router Configurations, and other technical details if they were disclosed by
                        QRTAs to you;
                    </li>
                    <li>
                        You hereby agree that, in the interest of data security, should QRTAs
                        observe or apprehend a risk of unauthorized access, QRTAs will, at its sole
                        discretion; terminate access at QRTAs' end with or without a reasonable
                        notice to you;
                    </li>
                    <li>
                        You hereby acknowledge that the Intellectual Property Rights of QRTAs of its
                        various App/platform solutions including the App/platform in the Software
                        Systems, Procedures, Operating, Quality, Control, Audit and User Manuals,
                        Database Design, Screens, Source and Object Code, Reports etc. designed by
                        QRTAs are made available to you. You hereby agree to keep them confidential,
                        disclose only to employees, auditors or other third-party agents on a
                        need-to-know basis, and not to attempt to reverse engineer or otherwise
                        duplicate these designs directly or indirectly. You hereby also agree that
                        such information shall not be disclosed under any circumstances to
                        individuals or entities who / that may have a business interest competitive
                        to that of QRTAs.
                    </li>
                    <li>
                        You hereby represent and warrant that the entities or individuals authorized
                        by you and your respective group entities and your
                        officers/directors/employees, third parties representing you, advisers and
                        auditors shall access the MF Central appropriately and legally. Further
                        entities or individuals authorized by you and your respective group entities
                        and your officers/directors/employees, third parties representing you,
                        advisers and auditors shall be explained that their illegal usage of QRTAs
                        App/platforms and Data access would not only render immediate termination of
                        the access to the respective App/platform but also constrain you and the
                        concerned entities or individuals either jointly or severally to indemnify
                        QRTAs for any loss incurred by QRTAs by virtue of the illegal use.
                    </li>
                    <li>
                        You hereby acknowledge that the existing App/platform Solutions being
                        provided by QRTAs, or any other solutions will be made available to you from
                        time to time are subject to the directions issued and access controls made
                        by respective regulatory authority from time to time. QRTAs shall not be
                        held liable for any direct or indirect consequences under this context.
                    </li>
                    <li>
                        You hereby acknowledge that you and entities or individuals authorized by
                        you and your respective group entities and your
                        officers/directors/employees, third parties including your advisers and
                        auditors representing you shall use the QRTAs App/platforms in compliance
                        with these terms and conditions.
                    </li>
                </ol>
                <h3>Governing Law and Jurisdiction :</h3>
                <p>
                    In case of any dispute, claim or controversy arising out of or relating to these
                    Terms or the breach, termination, enforcement, interpretation or validity
                    thereof or the use of the MF Central (collectively “Disputes”), the respective
                    QRTA and you shall attempt to settle the same amicably, through negotiation and
                    consultation at such offices of the QRTA as the Company may designate.{' '}
                </p>
                <p>
                    In the event the dispute remains unresolved for 15 (fifteen) days, either party
                    may refer such dispute to arbitration according to the provisions of the
                    Arbitration and Conciliation Act of 1996, amended from time to time, to a sole
                    arbitrator appointed mutually by the parties.
                </p>
                <p>
                    The language of the arbitration shall be English and the arbitral award shall be
                    binding on both the parties.
                </p>
                <p>
                    The seat and venue of the arbitration shall be Chennai, State of Tamil Nadu,
                    unless otherwise mutually agreed by the QRTA and you.
                </p>
                <p>
                    The court of law at Chennai, State of Tamil Nadu shall have the exclusive
                    jurisdiction over any disputes arising under this arrangement.
                </p>
                <h3>Changes :</h3>
                <p>
                    QRTAs reserves the rights, at its sole discretion, to change, modify, add or
                    remove any portion of the Terms and Conditions of Terms of Use in whole or in
                    part, at any time. Changes in these Terms of Use will be effective when notice
                    of such change is posted. User’s continued use of the MF Central after any
                    changes are posted will be considered acceptance of those changes.{' '}
                </p>
                <h3>Survival :</h3>
                <p>
                    You hereby agree that the clauses on Confidentiality, Liability & Indemnity and
                    Intellectual Property shall survive even after you cease to use the MF Central
                    /App/platform.
                </p>
                <h3>Miscellaneous :</h3>
                <p>
                    The headings in this document are for convenience only and are not intended to
                    have any legal effect nor purport to be complete or accurate descriptions of the
                    content thereof and shall not be used to interpret the provisions of this
                    document.
                </p>
                <p>
                    In the event, any of the aforesaid terms and conditions shall be rendered/held
                    to be unenforceable due to any regulatory changes, the remaining terms and
                    conditions shall be unimpaired, and the unenforceable term or condition shall be
                    replaced by such enforceable term or condition as may come closest to the
                    intention underlying the unenforceable term or condition.
                </p>
                <p>
                    No waiver of any breach or default of the Agreement shall be deemed to be a
                    waiver of any preceding or subsequent breach or default.
                </p>
            </div>
        </div>
    );
}
export default TermsOfUse;
